import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const SelectImageResourcePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "SelectImageResourcePopup" */ './Container'),
  'popup'
);
